import React, { FC, ReactNode, useMemo } from 'react';
import { Menu } from 'antd';
import { CountBadge } from 'common/components';
import { ESearchParams } from 'common/const';
import { useSearchParamsHook } from 'common/hooks';
import { useAppSelector } from 'app/store/store.hooks';
import { EInventoryActionListTab } from 'entities/Inventory/Inventory.enum';
import { IncomingWriteOffInventoryActionListTab } from 'entities/Inventory/components';
import { selectUserInventoryStats } from 'entities/User/User.slice';

interface IComponentProps {
  header: ReactNode;
}

export const WriteOffInventoryActionListTab: FC<IComponentProps> = ({ header }) => {
  // user
  const userInventoryStats = useAppSelector(selectUserInventoryStats);

  const { getSearchParam, setSearchParam } = useSearchParamsHook();

  const { writeOffsCount } = userInventoryStats;
  const tab = getSearchParam(ESearchParams.Tab);
  const menu = useMemo(() => {
    return (
      <Menu
        items={[
          {
            key: EInventoryActionListTab.Incoming,
            label: (
              <>
                Входящие запросы
                <CountBadge count={writeOffsCount} />
              </>
            ),
          },
        ]}
        selectedKeys={[tab === null ? EInventoryActionListTab.Incoming : tab]}
        onClick={({ key }) => setSearchParam(ESearchParams.Tab, key)}
        mode="horizontal"
      />
    );
  }, [tab, userInventoryStats]);

  return <IncomingWriteOffInventoryActionListTab header={header} menu={menu} />;
};
